<template>
	<section
		class="screen"
		:class="[
			type ? 'screen-type--' + type : '',
			institution && 'extra-head'
		]"
	>
		<div class="institution" v-if="institution">
			<slot name="logo"></slot>
			<div class="header">
				<p class="subtext">You're donating to</p>
				<div class="ellipsis">
					<slot name="org_name"></slot>
				</div>
			</div>
		</div>
		<div class="screen-header">
			<slot name="header"></slot>
		</div>
		<div class="screen-content">
			<slot></slot>
		</div>
	</section>
</template>

<script>
export default {
	name: 'roundup-screen',
	props: ['type', 'institution']
}
</script>

<style lang="scss">
.screen {
	background: $bone;
	position: relative;
	box-shadow: 0px 3px 30px rgba(0, 0, 0, 0.15);
	margin-top: 20px;
	margin-bottom: 20px;
	padding: 40px;
	border-radius: 14px;
	overflow: auto !important;
	width: 100%;
	@media screen and (max-width: 480px) {
		margin-top: 0px;
		border-radius: 0px;
		padding: 10px 25px 25px;
		box-shadow: none;
		min-height: 100%;
	}
	&.screen-type--blue {
		background: $navy;
		.institution {
			background-color: rgba(0, 0, 0, 0.1);
		}
	}
	&.screen-type--cerulean {
		background: $cerulean;
	}
	&.extra-head {
		padding-top: 100px;
	}
	label {
		padding-bottom: 10px;
		display: block;
		position: relative;
		.roundup-button {
			margin-top: 10px;
			width: 100%;
		}
	}
	.institution {
		background: $navy;
		position: absolute;
		top: 0;
		height: 72px;
		width: 100%;
		left: 0px;
		padding: 16px 40px;
		display: flex;
		flex-direction: row;
		.header {
			margin-left: 20px;
			max-lines: 1;
			max-height: 1em;
			p {
				margin-top: -5px;
				display: block;
				text-overflow: ellipsis;
				word-wrap: break-word;
				overflow: hidden;
				max-height: 1.5em;
				line-height: 1.5em;
				height: 1.5em;
				@media (max-width: 480px) {
					.ellipsis {
						text-overflow: ellipsis;
					}
				}
				&.subtext {
					color: rgba(255, 255, 255, 0.5);
					font-size: 13px;
					margin-bottom: 0px;
				}
			}
		}
		@media (max-width: 480px) {
			.ellipsis {
				display: block;
				text-overflow: ellipsis;
				word-wrap: break-word;
				overflow: hidden;
				max-height: 1.5em;
				line-height: 1.5em;
				height: 1.5em;
				white-space: nowrap;
				width: 250px;
				@media (max-width: 350px) {
					width: 190px;
				}
			}
		}
	}
}
</style>
